import { ActionTree } from 'vuex'
import { MapState } from './types'
import { RootState } from '../types'

export const actions: ActionTree<MapState, RootState> = {
  initMapState({ commit }): any {
    const payload: MapState = {
      zones: {},
      map: {},
      currentZone:{}
    }
    commit('initMapState', payload)
  },
  setMap({commit}, payload){
    commit('setMap', payload)
  },
  currentGeofence({commit},payload){
    commit('currentGeofence', payload)
  }
}
